import Alpine from "alpinejs";

// PLUGINS
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import morph from "@alpinejs/morph";
import ui from "@alpinejs/ui";
import dialog from "./plugins/dialog";

import swiper from "@goldencomm/alpine-plugin-swiper";

/* Date picker */
import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

/* Swiper Core */
import Swiper from "swiper";

/* (Optional) Swiper Modules */
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(morph);
Alpine.plugin(ui);
Alpine.plugin(dialog);

import history from "./plugins/history";
import share from "./plugins/share";

Alpine.plugin(history);
Alpine.plugin(share);

Alpine.plugin(swiper(Swiper));

// STORES
import cart from "./stores/cart";
Alpine.store("cart", cart);

// COMPONENTS
import media from "./components/media";
Alpine.data("media", media);

import product from "./components/product";
Alpine.data("product", product);

import productRecommendations from "./components/productRecommendations";
Alpine.data("productRecommendations", productRecommendations);

import numberInput from "./components/numberInput";
Alpine.data("numberInput", numberInput);

import validation from "./components/validation";
Alpine.data("validation", validation);

window.Alpine = Alpine;

// INIT
Alpine.start();
